import React, { useState, useEffect } from "react";
import {
    Col,
    Label,
    Row,
    Form,
    Button,
    Spinner,
    FormGroup,
} from "reactstrap";
import { post, get } from "../../../Services/RestAPIService";
import { useFormik } from "formik";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useNavigate } from "react-router-dom";

const SelectCategories = ({ OnSubmit, Response, Data, Alerts, Loading }) => {
    const animatedComponents = makeAnimated();
    const [selectedExercises, setSelectedExercises] = useState([]);
    const [exerciseOptions, setExerciseOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        getUsersData();
        getSelectedExercises();
        
    }, []);

    const getUsersData = async () => {
        try {
            const response = await get(`category/categorywithexericse/`);
            const data = response;

            // Format the data into the structure needed for react-select
            let formattedData
            if (data) {
                formattedData = data.map((category) => ({
                    label: category.name,
                    options: category.exercises.map((exercise) => ({
                        label: exercise.exercise_name,
                        value: exercise.id.toString(),
                    })),
                }));
            } else {
                console.error('No data found in the response.');
            }
            console.error('formattedData'+formattedData,data);

            setExerciseOptions(formattedData);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {

        console.log(selectedExercises);
    }, [selectedExercises]);



    const getSelectedExercises = async () => {
        try {
            const data = await get(`assign/assigned/?user_id=${Data}`);
            // setUserData(data);
            console.log(data?.results[0]?.exercises, "data")
            const ExerciseData = data?.results[0]?.exercises
            let formattedData
    
            if (ExerciseData) {
                formattedData = ExerciseData.map((category) => ({
                    label: category.exercise_name,
                    value: category.id.toString(),
                }));
            }
            console.log("selectedExercises:", formattedData);
            setTimeout(() => {
                setSelectedExercises(formattedData);
            }, 1500);
            // Uncomment this line to set the state
        } catch (error) {
            console.error("Error fetching user data:", error);
        }
    };


    const handleCategories = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        const exerciseIds = selectedExercises.map((exercise) => exercise.value);

        const formData = {
            user_id: Data,
            exercises: exerciseIds,
            status: true,
        };
        console.log(formData, "formdata")
        try {
            const response = await post("assign/assigned/", formData);
            if (response.status <= 399) {
                Alerts({
                    color: "success",
                    visible: true,
                    message: "Categories submitted successfully.",
                    strongM: "Success!",
                });

                // Response(3)
                // Navigate to the next step if applicable
                // navigate('/next-step');
            } else {
                Alerts({
                    color: "danger",
                    visible: true,
                    message: "An error occurred.",
                    strongM: "Error!",
                });
            }
        } catch (error) {
            console.error('Error submitting categories:', error);
            Alerts({
                color: "danger",
                visible: true,
                message: "An error occurred.",
                strongM: "Error!",
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <React.Fragment>
            <Form id="CategoriesSelect" onSubmit={handleCategories}>
                <Col lg="6">
                    <FormGroup className="mb-3 templating-select select2-container">
                        <Label className="control-label">Select Exercises</Label>

                        <Select
                            value={selectedExercises}
                            isMulti
                            onChange={(selectedOptions) => setSelectedExercises(selectedOptions)}
                            options={exerciseOptions}
                            classNamePrefix="select2-selection"
                            closeMenuOnSelect={false}
                            components={animatedComponents}
                            isLoading={isLoading}
                        />



                    </FormGroup>

                    {/* {isLoading && */}
                        <Button type="submit" color="primary" disabled={isLoading}>
                            {isLoading ?
                                <Spinner size="sm" color="gray" />
                                : "Submit"}
                        </Button>
                    {/* } */}
                </Col>

            </Form>


            <Row className=" mb-5"></Row>
            <Row className=" mb-5"></Row>

            <Row className=" mb-5"></Row>
            <Row className=" mb-5"></Row>
        </React.Fragment>
    );
};

export default SelectCategories;
